import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {isDesktop} from 'src/logic/utils';
import cx from 'classnames';
import Media from 'react-responsive';
import {Table, Thead, Tbody, Tr, Td, Th} from 'reactable';
import styles from './ModificationsTable.scss';
import {Link} from 'react-router';
import _ from 'lodash';
import {getIdByURL} from 'src/logic/utils';
import stylesMobile from '../CatalogMobile.scss';


export default function ModificationsTable(props) {
    const modificationList = props.modificationList;

    const tableRows = _.map(modificationList, (item, i) => {

      return (
          <Tr>
            <Td column="Модификация">
              <Link
                to={`/components/${item.modificationId}`}
                key={`component{i}`}
                className="link">
                {item.modificationName}
              </Link>
            </Td>
            <Td column="Кузов">
               Седан
            </Td>
            <Td column="Модель двигателя">
              {item.engineModel}
            </Td>
            <Td column="Объем двигателя, л.">
              {item.engineVolume}
            </Td>
            <Td column="Мощность, л.с.">
              {item.enginePower}
            </Td>
            <Td column="Год выпуска">
              {item.modificationYearStart + ' - ' + (item.modificationYearEnd?item.modificationYearEnd:'наст. время')}
            </Td>
          </Tr>
      );
    });

    const tableRowsMobile = _.map(modificationList, (item, i) => {
      return (
        <div className={stylesMobile.drop_down_category}>
          <Link
            to={`/components/${item.modificationId}`}
            key={`component{i}`}
            >
            <Table className={styles.table}>
              <Tr>
                <Td column="Модификация">
                  {item.modificationName}
                </Td>
                <Td column="Кузов">
                  'Купэ'
                </Td>
                <Td column="Модель двигателя">
                  {item.engineModel}
                </Td>
                <Td column="Объем двигателя, л.">
                  {item.engineVolume}
                </Td>
                <Td column="Мощность, л.с.">
                  {item.enginePower}
                </Td>
                <Td column="Год выпуска">
                  {item.releaseYear + ' - '}{item.endReleaseYear?item.endReleaseYear:'наст. время'}
                </Td>
              </Tr>
            </Table>
          </Link>
        </div>
      )
    });
    return (
      <div>
        <Media query="(min-width: 1025px)">
          <Table className={styles.table}>
            {tableRows}
          </Table>
        </Media>
        <Media query="(max-width: 1024px)">
          {tableRowsMobile}
        </Media>
      </div>
    );
  }

  ModificationsTable.propTypes = {
  };



/** WEBPACK FOOTER **
 ** ./src/components/Catalog/elements/ModificationsTable.jsx
 **/